import { themeEvents } from "./events";
import { hasInitializedRoute, markRouteInitialized } from "./state";
import { mark } from "./telemetry";
import { detectTemplateNameFromBody } from "./route-template";
import type { RouteContext, TemplateName } from "../types/route-context";

type RouteInitializer = (context: RouteContext) => void | Promise<void>;

async function loadRouteInitializer(template: TemplateName): Promise<RouteInitializer | null> {
  switch (template) {
    case "home":
      return (await import("../entry/route-home")).default;
    case "collection":
      return (await import("../entry/route-collection")).default;
    case "product":
      return (await import("../entry/route-product")).default;
    case "search":
      return (await import("../entry/route-search")).default;
    case "cart":
      return (await import("../entry/route-cart")).default;
    case "blog":
      return (await import("../entry/route-blog")).default;
    case "article":
      return (await import("../entry/route-article")).default;
    case "page":
      return (await import("../entry/route-page")).default;
    case "customer":
      return (await import("../entry/route-customer")).default;
    case "password":
      return (await import("../entry/route-password")).default;
    case "gift_card":
      return (await import("../entry/route-gift-card")).default;
    default:
      return null;
  }
}

export async function bootApplication(): Promise<void> {
  const body = document.body as HTMLBodyElement | null;
  if (!body) {
    return;
  }
  const template = detectTemplateNameFromBody(body);
  const context: RouteContext = { body, template };
  const routeKey = `route:${template}`;

  if (hasInitializedRoute(routeKey)) {
    return;
  }

  mark("app:boot:start");
  themeEvents.emit("app:booted", { template });

  const routeInitializer = await loadRouteInitializer(template);
  if (routeInitializer) {
    await routeInitializer(context);
    themeEvents.emit("route:initialized", { template });
  }

  markRouteInitialized(routeKey);
  mark("app:boot:end");
}
